import React, {useCallback, useMemo} from 'react';

import {SortDirection as SortDirections} from 'src/openapi/admin/models/SortDirection';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group} from '@pb/kit-component-group';
import Icon, {Icons} from '@pb/kit-component-icon';


import {userNotificationsTopic} from '../../user-notifications.module.styl';

import {NotificationLink} from './notification-link';


import type {Notification} from 'src/openapi/admin/models/Notification';
import type {SortDirection} from 'src/openapi/admin/models/SortDirection';

type Props = {
    topic: string,
    expandedTopics: string[],
    notifications: Notification[],
    dateSortDirection: SortDirection,
    onToggleTopic: (topic: string) => void,
};

export const Topic = ({onToggleTopic, topic, notifications, expandedTopics, dateSortDirection}: Props) => {
    const toggleTopic = useCallback(() => {
        onToggleTopic(topic);
    }, [onToggleTopic, topic]);

    const dateSortComparator = useCallback((a: Notification, b: Notification) => {
        if (dateSortDirection === SortDirections.ASC) {
            return a.startDate.localeCompare(b.startDate);
        } else {
            return b.startDate.localeCompare(a.startDate);
        }
    }, [dateSortDirection]);

    const inTopicNotifications = useMemo(() => (
        notifications.filter(notification => notification.topic === topic)
    ), [notifications, topic]);

    const isTopicExpanded = useMemo(() => expandedTopics.includes(topic), [expandedTopics, topic]);

    return (
        <Group direction="v" gap="xs" as="li">
            <Group
                key={topic}
                className={userNotificationsTopic}
                alignItems="center"
                gap="s"
                onClick={toggleTopic}
                as="header">
                <Icon type={isTopicExpanded ? Icons.ANGLE_UP : Icons.ANGLE_DOWN}/>
                <EllipsisTextHint title={topic}>
                    <b>{topic}</b>
                </EllipsisTextHint>
            </Group>
            {isTopicExpanded ? (
                <Group direction="v" gap="xs" as="ul" className="pdx-m">
                    {inTopicNotifications.sort(dateSortComparator).map(notification => (
                        <li key={notification.notificationId}>
                            <NotificationLink notification={notification}/>
                        </li>
                    ))}
                </Group>
            ) : null}
        </Group>
    );
};
